import { createSlice } from "@reduxjs/toolkit";
import { InstanceApi } from "../../helpers/InstanceApi";
import { Validate } from "../../helpers/Validate";
import { setPopup } from "../popupSlice";

export const userRightSlice = createSlice({
  name: "userRight",
  initialState: {
    openModal: false,
    dataTables: undefined,
    dataOptions: [],
    dataOptionUser: [],
    dataOptionEmployee: [],
    dataOptionPosition: [],
    dataFilter: [],
    dataView: undefined,
    formValidate: {
      name: { required: true, title: "User Right Name" },
      type: { required: true, title: "Type" },
    },
    formData: {
      id: "",
      name: "",
      type: "",
      reference_id: "",
      roles: "",
    },
  },
  reducers: {
    resetDataView: (state) => {
      state.dataView = undefined;
    },
    setModal: (state, action) => {
      state.openModal = action.payload;
    },
    setDataTables: (state, action) => {
      state.dataTables = action.payload;
    },
    setDataOptionUser: (state, action) => {
      state.dataOptionUser = action.payload;
    },
    setDataOptionEmployee: (state, action) => {
      state.dataOptionEmployee = action.payload;
    },
    setDataOptionPosition: (state, action) => {
      state.dataOptionPosition = action.payload;
    },
    setDataOptions: (state, action) => {
      state.dataOptions = action.payload;
    },
    setDataFilter: (state, action) => {
      state.dataFilter = action.payload;
    },
    setDataView: (state, action) => {
      state.dataView = action.payload;
    },
    setFormData: (state, action) => {
      state.formData[action.payload.name] = action.payload.value;
    },
  },
});

export const resetFormData = () => async (dispatch, getState) => {
  const formData = getState().userRight.formData;
  Object.keys(formData).forEach((key) => {
    dispatch(setFormData({ name: key, value: "" }));
  });
};

export const getDataTables = () => async (dispatch) => {
  try {
    dispatch(setDataTables(undefined));
    dispatch(setDataView(undefined));
    dispatch(setPopup({ open: true, type: "loading" }));

    const response = await InstanceApi.get("/um/user-rights");
    if (response) {
      dispatch(setDataTables(response.data.data));
      dispatch(setPopup({ open: false }));
    }
  } catch (error) {
    console.log(error);
  }
};

export const getDataOptionUser = (params) => async (dispatch) => {
  try {
    let response;
    if(params){
      response = await InstanceApi.get(`/um/user-rights/user-list?reference_id=${params.id}`);
    } else {
      response = await InstanceApi.get(`/um/user-rights/user-list`);
    }
    if (response) {
      const data = response.data.data.map((item) => {
        return { value: item.id, label: item.name };
      });

      dispatch(setDataOptionUser(data));
    }
  } catch (error) {
    console.log(error);
  }
};
export const getDataOptionEmployee = (params) => async (dispatch) => {
  try {
    let response;
    if(params){
      response = await InstanceApi.get(`/um/user-rights/employee-list?reference_id=${params.id}`);
    } else {
      response = await InstanceApi.get(`/um/user-rights/employee-list`);
    }
    if (response) {
      const data = response.data.data.map((item) => {
        return { value: item.id, label: item.fullname };
      });

      dispatch(setDataOptionEmployee(data));
    }
  } catch (error) {
    console.log(error);
  }
};
export const getDataOptionPosition = (params) => async (dispatch) => {
  try {
    let response;
    if(params){
      response = await InstanceApi.get(`/um/user-rights/position-list?reference_id=${params.id}`);
    } else {
      response = await InstanceApi.get(`/um/user-rights/position-list`);
    }
    if (response) {
      const data = response.data.data.map((item) => {
        return { value: item.id, label: item.position_name };
      });

      dispatch(setDataOptionPosition(data));
    }
  } catch (error) {
    console.log(error);
  }
};
export const getDataOptions = () => async (dispatch) => {
  try {
    const response = await InstanceApi.get("/um/user-rights");
    if (response) {
      const data = response.data.data.map((item) => {
        return { value: item.id, label: item.userRight_name };
      });

      dispatch(setDataOptions(data));
    }
  } catch (error) {
    console.log(error);
  }
};

export const getDataView = (params) => async (dispatch) => {
  try {
    dispatch(setPopup({ open: true, type: "loading" }));

    const response = await InstanceApi.get("/um/user-rights/" + params.id);
    if (response) {
      dispatch(setDataView(response.data.data));
      dispatch(setPopup({ open: false }));
    }
  } catch (error) {
    dispatch(
      setPopup({
        open: true,
        type: "error",
        message: error.message,
        handleOk: () => {
          dispatch(setPopup({ open: false }));
        },
      })
    );
    console.error(error.response.data.message);
  }
};

export const getFormData = (params) => async (dispatch, getState) => {
  try {
    dispatch(resetFormData());
    dispatch(setPopup({ open: true, type: "loading" }));

    const response = await InstanceApi.get("/um/user-rights/" + params.id);
    if (response) {
      const data = response.data.data;
      const formData = getState().userRight.formData;
      Object.keys(formData).forEach((key) => {
        dispatch(setFormData({ name: key, value: data?.[key] ?? "" }));
      });

      dispatch(setPopup({ open: false }));
    }
  } catch (error) {
    dispatch(
      setPopup({
        open: true,
        type: "error",
        message: error.message,
        handleOk: () => {
          dispatch(setPopup({ open: false }));
        },
      })
    );
    console.error(error.response.data.message);
  }
};

export const getFormDataCopy = (params) => async (dispatch, getState) => {
  try {
    dispatch(resetFormData());
    dispatch(setPopup({ open: true, type: "loading" }));

    const response = await InstanceApi.get("/um/user-rights/" + params.id);
    if (response) {
      const data = response.data.data;
      const formData = getState().userRight.formData;
      Object.keys(formData).forEach((key) => {
        if(key === 'roles'){
          dispatch(setFormData({ name: key, value: data?.[key] ?? "" }));
        }
      });

      dispatch(setPopup({ open: false }));
    }
  } catch (error) {
    dispatch(
      setPopup({
        open: true,
        type: "error",
        message: error.message,
        handleOk: () => {
          dispatch(setPopup({ open: false }));
        },
      })
    );
    console.error(error.response.data.message);
  }
};

export const submit = (params) => async (dispatch, getState) => {
  try {
    dispatch(setPopup({ open: true, type: "processing" }));
    const formValidate = getState().userRight.formValidate;
    const formData = getState().userRight.formData;
    const validate = Validate(formValidate, formData);

    if (!validate.isValid) {
      dispatch(
        setPopup({
          open: true,
          type: "error",
          message: validate.message,
          handleOk: () => {
            dispatch(setPopup({ open: false }));
          },
        })
      );
    } else {
      let response = "";
      if (params.formType === "create") {
        response = await InstanceApi.post("/um/user-rights", {data: formData, roles: params.roles});
        dispatch(
          setPopup({
            open: true,
            type: "success",
            message: response.data.message,
            handleOk: () => {
              dispatch(setPopup({ open: false }));
              dispatch(setModal(false));
              dispatch(resetFormData());
              window.location.href = "/um/user-rights";
            },
          })
        );
      } else {
        response = await InstanceApi.patch("/um/user-rights/" + formData.id, {
          data: formData,
          roles: params.roles,
        });
        dispatch(
          setPopup({
            open: true,
            type: "success",
            message: response.data.message,
            handleOk: () => {
              dispatch(setPopup({ open: false }));
              dispatch(setModal(false));
              dispatch(resetFormData());
              window.location.href = "/um/user-rights";
            },
          })
        );
      }
    }
  } catch (err) {
    dispatch(
      setPopup({
        open: true,
        type: "error",
        message: err.message,
        handleOk: () => {
          dispatch(setPopup({ open: false }));
        },
      })
    );
    console.error(err.response.data.message);
  }
};

export const deleteData = (params) => (dispatch) => {
  try {
    dispatch(
      setPopup({
        open: true,
        type: "confirm",
        message: "Are you sure to delete this data?",
        handleOk: async () => {
          try {
            const response = await InstanceApi.delete(
              "/um/user-rights/" + params.id
            );
            if (response) {
              dispatch(
                setPopup({
                  open: true,
                  type: "success",
                  message: response.data.message,
                  handleOk: () => {
                    dispatch(setPopup({ open: false }));
                    dispatch(getDataTables());
                  },
                })
              );
            }
          } catch (error) {
            dispatch(
              setPopup({
                open: true,
                type: "error",
                message: error.message,
                handleOk: () => {
                  dispatch(setPopup({ open: false }));
                },
              })
            );
          }
        },
        handleCancel: () => {
          dispatch(setPopup({ open: false }));
        },
      })
    );
  } catch (err) {
    dispatch(
      setPopup({
        open: true,
        type: "error",
        message: err.message,
        handleOk: () => {
          dispatch(setPopup({ open: false }));
        },
      })
    );
  }
};

export const {
  resetDataView,
  setModal,
  setDataTables,
  setDataOptionUser,
  setDataOptionEmployee,
  setDataOptionPosition,
  setDataOptions,
  setDataFilter,
  setDataView,
  setFormData,
} = userRightSlice.actions;
export default userRightSlice.reducer;
